var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBestsellers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#bestsellers_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M23 6a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2v25c0 8.837-7.163 16-16 16h-2c-8.837 0-16-7.163-16-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 7h11M40 60h8M45 10h11M42 63h6M45 13h11M42 66h6M45 16h11M42 69h6M45 19h11M45 22h11M45 25h11M45 28h11M45 31h11M45 34h11M44 37h11M43 40h12M41 43h11"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M32 71h16V61a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4zM25 75.444c0 .307.249.556.556.556h29.15a.294.294 0 0 0 .294-.294A4.706 4.706 0 0 0 50.294 71h-20.85A4.444 4.444 0 0 0 25 75.444ZM36 47h8v10h-8zM23 12h-8.64a2 2 0 0 0-1.972 2.329l1.637 9.822A7 7 0 0 0 20.93 30H23M57 12h8.64a2 2 0 0 1 1.972 2.329l-1.637 9.822A7 7 0 0 1 59.07 30H57"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bestsellers_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: "1em",
  height: "1em",
  fill: "#fff"
})))));
export default SvgBestsellers;